module.exports = __webpack_public_path__ + "img/cloud-disable.cdd48d94.svg";